import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { InvoicesTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getInvoicesActions: {
    request: Creators.getInvoicesRequest,
    success: Creators.getInvoicesSuccess,
    errors: Creators.invoicesFailure
  },
  getInvoicesExportActions: {
    request: Creators.getInvoicesExportRequest,
    success: Creators.getInvoicesExportSuccess,
    errors: Creators.getInvoicesExportFailure,
    downloadFile: true
  },
  getInvoicesExportForUserActions: {
    request: Creators.getInvoicesExportForUserRequest,
    success: Creators.getInvoicesExportSuccess,
    errors: Creators.getInvoicesExportFailure
  },
  getInvoicesExportHistoryActions: {
    request: Creators.getInvoicesExportHistoryRequest,
    success: Creators.getInvoicesExportSuccess,
    errors: Creators.getInvoicesExportFailure
  },
  reissueInvoiceActions: {
    request: Creators.reissueInvoiceRequest,
    success: Creators.reissueInvoiceSuccess,
    errors: Creators.invoicesFailure
  },
  updateInvoiceActions: {
    request: Creators.updateInvoiceRequest,
    success: Creators.updateInvoiceSuccess,
    errors: Creators.invoicesFailure
  },
  invoiceGeneratingActions: {
    request: Creators.invoiceGeneratingRequest,
    success: Creators.invoiceGeneratingSuccess,
    errors: Creators.invoiceGeneratingFailure
  },
  getInvoiceHistoryActions: {
    request: Creators.getInvoiceHistoryRequest,
    success: Creators.getInvoiceHistorySuccess,
    errors: Creators.getInvoiceHistoryFailure
    //fakeData: invoiceHistoryFakeData
  },
  getInvoicesFilterOptionsActions: {
    request: Creators.getInvoicesFilterOptionsRequest,
    success: Creators.getInvoicesFilterOptionsSuccess,
    errors: Creators.getInvoicesFilterOptionsFailure
  },
  getInvoiceDownloadActions: {
    request: Creators.getInvoiceDownloadRequest,
    success: Creators.getInvoiceDownloadSuccess,
    errors: Creators.getInvoiceDownloadFailure,
    downloadFile: true
  },
  getInvoicesStatusOptionsActions: {
    request: Creators.getInvoicesStatusOptionsRequest,
    success: Creators.getInvoicesStatusOptionsSuccess,
    errors: Creators.getInvoicesStatusOptionsFailure
  }
}

const eventsOptions = {
  [constants.GET_INVOICES_REQUEST]: {
    api: services.getInvoices,
    actions: actions.getInvoicesActions
  },
  [constants.GET_INVOICES_EXPORT_REQUEST]: {
    api: services.getInvoicesExport,
    actions: actions.getInvoicesExportActions
  },
  [constants.GET_INVOICES_EXPORT_FOR_USER_REQUEST]: {
    api: services.getInvoicesExport,
    actions: actions.getInvoicesExportForUserActions
  },
  [constants.GET_INVOICES_EXPORT_HISTORY_REQUEST]: {
    api: services.getInvoicesExport,
    actions: actions.getInvoicesExportHistoryActions
  },
  [constants.REISSUE_INVOICE_REQUEST]: {
    api: services.reissueInvoice,
    actions: actions.reissueInvoiceActions
  },
  [constants.UPDATE_INVOICE_REQUEST]: {
    api: services.updateInvoice,
    actions: actions.updateInvoiceActions
  },
  [constants.INVOICE_GENERATING_REQUEST]: {
    api: services.invoiceGenerating,
    actions: actions.invoiceGeneratingActions
  },
  [constants.GET_INVOICE_HISTORY_REQUEST]: {
    api: services.getInvoiceHistory,
    actions: actions.getInvoiceHistoryActions
  },
  [constants.GET_INVOICES_FILTER_OPTIONS_REQUEST]: {
    api: services.getInvoicesFilterOptions,
    actions: actions.getInvoicesFilterOptionsActions
  },
  [constants.GET_INVOICE_DOWNLOAD_REQUEST]: {
    api: services.getInvoiceDownload,
    actions: actions.getInvoiceDownloadActions
  },
  [constants.GET_INVOICES_STATUS_OPTIONS_REQUEST]: {
    api: services.getInvoicesStatusOptions,
    actions: actions.getInvoicesStatusOptionsActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_INVOICES_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICES_REQUEST])
  )
  yield takeLatest(constants.GET_INVOICES_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICES_EXPORT_REQUEST])
  )
  yield takeLatest(constants.GET_INVOICES_EXPORT_FOR_USER_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICES_EXPORT_FOR_USER_REQUEST])
  )
  yield takeLatest(constants.GET_INVOICES_EXPORT_HISTORY_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICES_EXPORT_HISTORY_REQUEST])
  )
  yield takeLatest(constants.REISSUE_INVOICE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.REISSUE_INVOICE_REQUEST])
  )
  yield takeLatest(constants.UPDATE_INVOICE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_INVOICE_REQUEST])
  )
  yield takeLatest(constants.INVOICE_GENERATING_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.INVOICE_GENERATING_REQUEST])
  )
  yield takeLatest(constants.GET_INVOICE_HISTORY_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICE_HISTORY_REQUEST])
  )
  yield takeLatest(constants.GET_INVOICES_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICES_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_INVOICE_DOWNLOAD_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICE_DOWNLOAD_REQUEST])
  )
  yield takeLatest(constants.GET_INVOICES_STATUS_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVOICES_STATUS_OPTIONS_REQUEST])
  )
}
